module.exports = __webpack_public_path__ + "media/images/pc/specials/common/bg-042545401dc4446bd6db257af2835b11.jpg";